<script>
    import {createEventDispatcher} from 'svelte';

    const dispatch = createEventDispatcher();

    export let id;
    export let label;
    export let value;
    export let valido = true;
    export let mensajeDeError = "";
    export let icono = false;
    export let disabled = false;

    let touched = false;
</script>

<style>
    label {
        display: block;
        margin-bottom: 0.5rem;
        width: 100%;
    }

    .form-control {
        padding: 0.5rem 0;
        width: 100%;
        margin: 0.25rem 0;
    }

    .error-message {
        color: red;
        margin: 0.25rem 0;
    }

    button {
        --color: var(--verde);
        --tamano: 35px;
        background: transparent;
        width: calc(var(--tamano) * 2);
        height: var(--tamano);
        border-radius: calc(var(--tamano) / 2);
        display: inline-block;
        position: relative;
        border: 1px solid var(--color);
        transition: .3s;
    }

    .bolita {
        width: calc(var(--tamano) - 4px);
        height: calc(var(--tamano) - 4px);
        position: absolute;
        left: 1px;
        background: var(--color);
        top: 1px;
        border-radius: 50%;
        transition: .3s;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-weight: bold;
        font-size: calc(var(--tamano) / 2.5);
        line-height: 1;
    }

    .disabled {
        opacity: .5;
    }

    button[aria-checked=true] {
        --color: var(--acentos);
    }

    button[aria-checked=true] .bolita {
        right: auto;
        left: calc(100% - var(--tamano) + 3px);
    }
</style>

<div class="form-control">
    <label for={id}>{label}</label>
    <div class="campo" class:invalid="{!valido && touched}" class:disabled>
        {#if icono}
            <div class="icono">
                <i class="material-icons">{icono}</i>
            </div>
        {/if}

        <button type="button" aria-checked={value ? 'true' : 'false'}
                {disabled} on:click={() => dispatch('change', !value)}>
            <span class="bolita">{value ? '|' : 'O'}</span>
        </button>
    </div>
    {#if mensajeDeError && !valido && touched}
        <p class="error-message">{mensajeDeError}</p>
    {/if}
</div>
